import { Box, Card, CardContent, Chip, Grid, Stack, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { useAuthStore } from '../../../auth/authStore';
import { PasswordChangeCard } from '../components/PasswordChangeCard';

/** Migration guide Bölüm 5.3 "Kullanıcı / Profil": read-only account summary +
 *  password change. Logout ("Çıkış") already lives in layout/Topbar.tsx per the task
 *  brief — not duplicated here. */
export default function ProfilePage() {
  const currentUser = useAuthStore((s) => s.currentUser);

  return (
    <Box sx={{ maxWidth: 720 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Profil
      </Typography>

      <Card variant="outlined" sx={{ mb: 3 }}>
        <CardContent>
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center', mb: 2 }}>
            <PersonIcon color="action" />
            <Typography variant="h6">Hesap Bilgileri</Typography>
            {currentUser?.isMasterGsa && <Chip size="small" color="primary" label="Master GSA" />}
          </Stack>
          <Grid container spacing={2}>
            <Grid size={{ xs: 6, md: 4 }}>
              <Typography variant="caption" color="text.secondary">
                Kullanıcı Adı
              </Typography>
              <Typography variant="body2">{currentUser?.userName || '—'}</Typography>
            </Grid>
            <Grid size={{ xs: 6, md: 4 }}>
              <Typography variant="caption" color="text.secondary">
                Acente
              </Typography>
              <Typography variant="body2">{currentUser?.gsaName || '—'}</Typography>
            </Grid>
            <Grid size={{ xs: 6, md: 4 }}>
              <Typography variant="caption" color="text.secondary">
                Acente Tipi
              </Typography>
              <Typography variant="body2">{currentUser?.gsaType || '—'}</Typography>
            </Grid>
            <Grid size={{ xs: 6, md: 4 }}>
              <Typography variant="caption" color="text.secondary">
                Kullanıcı Tipi
              </Typography>
              <Typography variant="body2">{currentUser?.userType || '—'}</Typography>
            </Grid>
            <Grid size={{ xs: 6, md: 4 }}>
              <Typography variant="caption" color="text.secondary">
                E-posta
              </Typography>
              <Typography variant="body2">{currentUser?.gsaEmail || '—'}</Typography>
            </Grid>
            <Grid size={{ xs: 6, md: 4 }}>
              <Typography variant="caption" color="text.secondary">
                Telefon
              </Typography>
              <Typography variant="body2">{currentUser?.gsaPhone || '—'}</Typography>
            </Grid>
            <Grid size={{ xs: 6, md: 4 }}>
              <Typography variant="caption" color="text.secondary">
                Para Birimi
              </Typography>
              <Typography variant="body2">{currentUser?.currency || '—'}</Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <PasswordChangeCard username={currentUser?.userName} />
    </Box>
  );
}
